export function isBra(productGroup) {
  let isBra = false;
  if (productGroup) {
    isBra = productGroup.current === "lounge-bra" || productGroup.current === "triangle-bra";
  }
  return isBra;
}
